const locale = 'pt-br';

export const currency = new Intl.NumberFormat(locale, {
  style: 'currency',
  currency: 'BRL',
});

export const decimal = new Intl.NumberFormat(locale, {
  minimumFractionDigits: 2,
});
